import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

//COMPONENTS
import Controller from "./files/controller";
import PlanDetails from "./files/planDetails";

function PodRouter() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    return (
        <div>
            {isLoaded && (
                <div>
                    <Routes>
                        <Route path={"/"} element={<Controller />} />
                        <Route path={"/plan/:id"} element={<PlanDetails />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
